import { Action, createReducer, on } from '@ngrx/store';

import { MenuItem } from 'src/app/core/models/main-menu.models';
import { setAppSection } from '../actions/core.actions';

export interface MainMenuState {
  menuItems: Array<MenuItem>;
  menuItemsSecondary: Array<MenuItem>;
  canToggleMenu: boolean;
  mainMenuLocked: boolean;
}

export const initialState: MainMenuState = {
  menuItems: [],
  menuItemsSecondary: [],
  canToggleMenu: true,
  mainMenuLocked: false,
};

const _mainMenuReducer = createReducer(
  initialState,
  on(setAppSection, (state, { appSection, menuItems }) => ({
    ...state,
    menuItems: !state.mainMenuLocked ? menuItems : state.menuItems || [],
  })),
);

export function mainMenuReducer(
  state: MainMenuState | undefined,
  action: Action,
) {
  return _mainMenuReducer(state, action);
}
